var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4E694251-CEA3-4593-B73A-6B8BFFF6DF4F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-881.000000, -400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(882.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.69094,22.34545 C44.69094,34.68645 34.68654,44.69085 22.34544,44.69085 C10.00444,44.69085 4e-05,34.68645 4e-05,22.34545 C4e-05,10.00435 10.00444,-5e-05 22.34544,-5e-05 C34.68654,-5e-05 44.69094,10.00435 44.69094,22.34545 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69094,22.34545 C44.69094,34.68645 34.68654,44.69085 22.34544,44.69085 C10.00444,44.69085 4e-05,34.68645 4e-05,22.34545 C4e-05,10.00435 10.00444,-5e-05 22.34544,-5e-05 C34.68654,-5e-05 44.69094,10.00435 44.69094,22.34545 Z",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6613,9.90775 C19.9653,9.10055 17.833,6.59655 17.833,6.59655 C17.833,6.59655 15.7008,9.10055 15.0048,9.90765 C10.1536,15.53385 6.6485,19.59885 6.6485,25.23235 C6.6485,31.39945 11.6658,36.41685 17.833,36.41685 C24.0003,36.41685 29.0176,31.39955 29.0176,25.23235 C29.0176,19.59885 25.5124,15.53395 20.6613,9.90775 Z",
    id: "Stroke-5",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.03322,
    y1: 30.4933,
    x2: 20.44332,
    y2: 30.4933,
    id: "Stroke-7",
    stroke: "#DF6532",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.74587,
    y1: 27.31469,
    x2: 17.74587,
    y2: 32.72479,
    id: "Stroke-9",
    stroke: "#DF6532",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83303,16.54408 C20.79783,16.54408 23.20143,18.83578 23.20143,21.66278 C23.20143,24.48968 20.79783,26.78138 17.83303,26.78138 C14.86823,26.78138 12.46463,24.48968 12.46463,21.66278 C12.46463,18.83578 14.86823,16.54408 17.83303,16.54408 Z",
    id: "Stroke-11",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.01755,
    y1: 32.08109,
    x2: 36.91475,
    y2: 32.08109,
    id: "Stroke-13",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.96613,
    y1: 28.13246,
    x2: 32.96613,
    y2: 36.02976,
    id: "Stroke-15",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9302,8.0476 C43.9302,12.2633 40.5127,15.6808 36.2969,15.6808 C32.0812,15.6808 28.6637,12.2633 28.6637,8.0476 C28.6637,3.8319 32.0812,0.4143 36.2969,0.4143 C40.5127,0.4143 43.9302,3.8319 43.9302,8.0476",
    id: "Fill-17",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04275,
    y1: 5.7934,
    x2: 38.55115,
    y2: 10.3018,
    id: "Stroke-19",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-21",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23);
export default __webpack_public_path__ + "static/media/Group 23.f9b26288.svg";
export { ForwardRef as ReactComponent };